import React from "react";
import Image from "next/image";
import Remote from "../LoaderRemote";
import { useTranslation } from "../../context/TranslationContext";

const BankaItem = ({ item }) => {
  const {
    bankItemBankName,
    bankItemBankBranch,
    bankItemBankAccountName,
    bankItemBankIban,
  } = useTranslation();
  return (
    <table className="table border border-[#ccc] mb-8 w-full">
      <tbody>
        <tr>
          <td rowSpan={9} className="w-80  hidden sm:table-cell">
            <div className="flex items-center justify-center">
              <div className="object-contain w-56 h-40 relative">
                <Image
                  layout="fill"
                  src={item.resim + "?l=0"}
                  loader={Remote}
                  objectFit={"contain"}
                  alt=""
                ></Image>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td colSpan={2} className="w-80  table-cell sm:hidden">
            <div className="flex items-center justify-center">
              <div className="object-contain w-56 h-40 relative">
                <Image
                  layout="fill"
                  src={item.resim + "?l=0"}
                  loader={Remote}
                  objectFit={"contain"}
                  alt=""
                ></Image>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td className="p-2 border-t border-[#ccc] border-l border-r font-semibold text-13 bg-[#efefef]">
            {bankItemBankName}
          </td>
          <td className="p-2 border-t border-[#ccc] font-normal text-13">
            {item.banka}
          </td>
        </tr>
        <tr>
          <td className="p-2 border-t border-[#ccc] border-l border-r font-semibold text-13 bg-[#efefef]">
            {bankItemBankBranch}
          </td>
          <td className="p-2 border-t border-[#ccc] font-normal text-13">
            {item.sube}
          </td>
        </tr>
        <tr>
          <td className="p-2 border-t border-[#ccc]  border-l border-r font-semibold text-13 bg-[#efefef]">
            {bankItemBankAccountName}
          </td>
          <td className="p-2 border-t border-[#ccc]  font-normal text-13">
            {item.hesap_adi}
          </td>
        </tr>

        {item.iban_tl && (
          <tr>
            <td className="p-2 border-t border-[#ccc]  border-l border-r font-semibold text-13 bg-[#efefef]">
              ₺ {bankItemBankIban}
            </td>
            <td className="p-2 border-t border-[#ccc]  font-normal text-13">
              {item.iban_tl}
            </td>
          </tr>
        )}

        {item.iban_dolar && (
          <tr>
            <td className="p-2 border-t border-[#ccc]  border-l border-r font-semibold text-13 bg-[#efefef]">
              $ {bankItemBankIban}
            </td>
            <td className="p-2 border-t border-[#ccc]  font-normal text-13">
              {item.iban_dolar}
            </td>
          </tr>
        )}

        {item.iban_euro && (
          <tr>
            <td className="p-2 border-t border-[#ccc]  border-l border-r font-semibold text-13 bg-[#efefef]">
              € {bankItemBankIban}
            </td>
            <td className="p-2 border-t border-[#ccc]  font-normal text-13">
              {item.iban_euro}
            </td>
          </tr>
        )}

        {item.iban_pound && (
          <tr>
            <td className="p-2 border-t border-[#ccc]  border-l border-r font-semibold text-13 bg-[#efefef]">
              £ {bankItemBankIban}
            </td>
            <td className="p-2 border-t border-[#ccc]  font-normal text-13">
              {item.iban_pound}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default BankaItem;
